var render = function render(_c,_vm){return _c('footer',{staticClass:"the-footer flex-wrap justify-between",class:_vm.classes},[_c('p',[_c('span',[_vm._v("COPYRIGHT ©")]),_c('span',[_vm._v(_vm._s(new Date().getFullYear())+" ")]),_c('span',[_vm._v("Palace of Kebap")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }